import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

import Home from "../Screens/Home";
import Login from "../Screens/Login";
import Otp from "../Screens/Otp";
import ProductDetails from "../Screens/ProductDetails";
import AddProduct from "../Screens/AddProduct";
import MyAds from "../Screens/MyAdds";
import Catalogue from "../Screens/Catalogue";
import EditProduct from "../Screens/EditProduct";
import CatalogueProductsDetails from "../Screens/CatalogueProductsDetails";
import Cart from "../Screens/Cart";
import Bin from "../Screens/Bin";
import WalletScreen from "../Screens/WalletScreen";
import OrderConfirm from "../Screens/OrderConfirm";
import ShareAndEarn from "../Screens/ShareAndEarn";
import Profile from "../Screens/Profile";
import Settings from "../Screens/Settings";
import Status from "../Screens/Status";
// import NotFound from "../pages/NotFound";

const AppRoutes = () => {
  return (
    <HashRouter>
      <Header />

      <main style={{ minHeight: "90vh", padding: "0px", display: "flex", flexDirection: "column" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/product-details/:productId" element={<ProductDetails />} />
          <Route path="/AddProduct" element={<AddProduct />} /> 
          <Route path="/myadds" element={<MyAds />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/catalogue-product-details/:productId" element={<CatalogueProductsDetails />} />
          <Route path="/edit-product/:productId" element={<EditProduct />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/bin" element={<Bin />} />
          <Route path="/wallet" element={<WalletScreen />} />
          <Route path="/checkout" element={<OrderConfirm />} />
          <Route path="/share-earn" element={<ShareAndEarn />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/status" element={<Status />} />

          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
        <Footer />
      </main>

    </HashRouter>
  );
};

export default AppRoutes;
